import type { PageErrorDevModeProps } from "./page-error-dev-mode.type";

import { isAPIError } from "@/modules/error-boundary";

import "./page-error-dev-mode.style.less";

const devModeTitle = "🤖 Unexpected application Error!";

export const PageErrorDevMode = ({ error }: PageErrorDevModeProps) => {
  if (isAPIError(error)) console.error(error.response);

  return (
    <div className="page-error-dev-mode">
      <h1>{devModeTitle}</h1>
      {error instanceof Error && (
        <>
          <h2>{error.message}</h2>
          <pre>{error.stack}</pre>
        </>
      )}
      {isAPIError(error) && error.response?.data?.message ? (
        <pre>{error.response.data.message}</pre>
      ) : null}
    </div>
  );
};
